import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const SITE_NAME = 'Dragonfly Massage';
const GOOGLE_REVIEW_URL = 'https://search.google.com/local/writereview?placeid=ChIJa3wQ4m5lz4cRI79yEvBpS-w';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Dragonfly Massage | Massage Therapy in Springfield, MO',
      description: 'Customized massage therapy with CJ Berkstresser, LMT, in Springfield, MO. Every body is unique and worthy of special treatment.'
    }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/ServicesView.vue'),
    meta: {
      title: `Services | ${SITE_NAME}`,
      description: 'Swedish, deep tissue, prenatal, manual lymphatic drainage, kinetic stretching, table Thai, and combo massage sessions in Springfield, MO.'
    }
  },
  {
    path: '/corporate',
    name: 'corporate',
    component: () => import('../views/CorporateMassageView.vue'),
    meta: {
      title: `Corporate & Workplace Massage | ${SITE_NAME}`,
      description: 'On-site corporate and workplace chair or table massage for Springfield, MO businesses — half or full day, three-hour minimum.'
    }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue'),
    meta: {
      title: `Pricing | ${SITE_NAME}`,
      description: 'Dragonfly Massage session pricing for basic-rate and kinetic/Thai massage, plus the nap extension add-on.'
    }
  },
  {
    path: '/gift-cards',
    name: 'gift_cards',
    component: () => import('../views/GiftCardsView.vue'),
    meta: {
      title: `Gift Cards | ${SITE_NAME}`,
      description: 'Dragonfly Massage gift cards: send therapeutic massage by email or text, instantly or on a date you pick.'
    }
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('../views/AboutUsView.vue'),
    meta: {
      title: `About CJ | ${SITE_NAME}`,
      description: 'Meet CJ Berkstresser, LMT, and the story behind Dragonfly Massage.'
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FaqView.vue'),
    meta: {
      title: `FAQ | ${SITE_NAME}`,
      description: 'Answers to common questions about booking, what to expect, what to wear, and visiting Dragonfly Massage.'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
    meta: {
      title: `Privacy | ${SITE_NAME}`,
      description: 'How Dragonfly Massage handles data on this website.'
    }
  },
  {
    // Short address to give clients; opens the Google review box for the listing.
    // A route rather than public/review/, since pm2 serve can't serve a folder's index.html.
    path: '/review',
    name: 'review',
    component: HomeView,
    beforeEnter: () => {
      window.location.replace(GOOGLE_REVIEW_URL);
      return false;
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('../views/NotFoundPageView.vue'),
    meta: {
      title: `Page Not Found | ${SITE_NAME}`
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

const DEFAULT_DESCRIPTION = 'Customized massage therapy with CJ Berkstresser, LMT, in Springfield, MO.';

router.afterEach((to) => {
  document.title = (to.meta.title as string) || SITE_NAME;
  const description = (to.meta.description as string) || DEFAULT_DESCRIPTION;
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', description);
});

export default router;
